/*
 * @Author: your name
 * @Date: 2021-11-15 10:12:06
 * @LastEditTime: 2021-11-16 09:53:22
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cpms-admin\src\views\makeTicket\makeTicket.routing.ts
 */
export const MakeTicketRouting = [
  {
    path: "/ticket/makeTicket/list",
    name: "make-ticket-list",
    meta: { title: "开票管理" },
    component: () => import("@/views/ticket/makeTicket/list/index.vue"),
  },
  {
    hidden: true,
    path: "/ticket/makeTicket/create",
    name: "make-ticket-create",
    meta: { title: "新增开票登记",comName:"ticketMakeTicketFormCreate"},
    component: () => import("@/views/ticket/makeTicket/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/ticket/makeTicket/edit/:id",
    name: "make-ticket-edit",
    meta: { title: "编辑开票记录",comName:"ticketMakeTicketFormCreate" },
    component: () => import("@/views/ticket/makeTicket/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/ticket/makeTicket/detail/:id",
    name: "make-ticket-detail",
    meta: { title: "开票登记详情" },
    component: () => import("@/views/ticket/makeTicket/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/ticket/makeTicket/flowPrint/:id",
    name: "make-ticket-flowPrint",
    meta: { title: "打印详情" },
    component: () => import("@/views/ticket/makeTicket/flow-print/index.vue"),
  },
];
